import { Component, Input, OnInit } from '@angular/core';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
// import { ViolationsAttachmentsComponent } from '../../../pages/violations/violations-attachments/violations-attachments.component';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss']
})
export class CompanyDetailsComponent implements OnInit {
  @Input() cRNumber:any;
  @Input() loadDataFP: Observable<any>;
  
  crNumberFromRoute:any;
    company: any;

    loadviolationdataFP = new BehaviorSubject<any>('');

  constructor(private sharedService:SharedHttpService) { }

  ngOnInit(): void {
    if(this.loadDataFP){
        this.loadDataFP.subscribe((data) => {

            if (data != null && data.crnumber != null) {
                this.cRNumber = data.crnumber;
            }
        setTimeout(() => {
        this.loadData();
        }, 50); 
      });
    }
    else{
      this.loadData();
    }
    
  }
  loadData(){
  
    this.getCompanyInfo();
  }

  getCompanyInfo(){
    this.sharedService.get(`api/Company/GetAllInfoByCR?CR=${this.cRNumber}`).subscribe(res=>{
        this.company = res;
        this.loadviolationdataFP.next({ "violations": res.violations });

         

    })
   
  }

}
